import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import SignUp from './views/SignUp.vue';
import SignIn from './views/SignIn.vue';
import CreateAccountOrSignIn from './components/SignUp/CreateAccountOrSignIn.vue';
import PersonalInfo from './components/SignUp/PersonalInfo.vue';
import DiagnosisInfo from './components/SignUp/DiagnosisInfo.vue';
import ActivityInfo from './components/SignUp/ActivityInfo.vue';
import AvatarPictureInfo from './components/SignUp/AvatarPictureInfo.vue';
import Terms from './components/SignUp/Terms.vue';
import LovedOne from './components/SignUp/LovedOne.vue';

import Dashboard from './views/Dashboard.vue';
import Admin from './views/Admin.vue';
import AdminReviews from './components/Admin/AdminReviews.vue';
import AdminUsers from './components/Admin/AdminUsers.vue';
import AdminComments from './components/Admin/AdminComments.vue';

import WebRTC from '@/views/WebRTC.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/signin',
      component: SignIn,
      // children: [
      //   {path: '', name: 'signin', component: CreateAccountOrSignIn},
      // ],
    },
    {
      path: '/signup',
      component: SignUp,
      children: [
        {path: 'personal', name: 'personal', component: PersonalInfo},
        {path: 'diagnosis', name: 'diagnosis', component: DiagnosisInfo},
        {path: 'activities', name: 'activities', component: ActivityInfo},
        {path: 'upload', name: 'upload', component: AvatarPictureInfo},
        {path: 'terms', name: 'terms', component: Terms},
        {path: 'lovedone', name: 'lovedon', component: LovedOne},
      ],
    },
    {
      path: '/dashboard*',
      component: Dashboard,
      name: 'dashboard',
      props: (route) => ({route: route.path}),
    },
    {
      path: '/admin*',
      component: Admin,
      name: 'admin',
      props: (route) => ({route: route.path}),
    },

    // {
    //   path: '/rtc',
    //   name: 'rtc',
    //   component: WebRTC,
    // },
  ],
});
